import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import type React from "react";
import styled from "styled-components";

const FieldWrapper = styled.div`
  margin-bottom: 24px;
  text-align: left;
`;

const LabelRow = styled.label`
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center;
  gap: 4px;
  margin-bottom: 6px;
  font-weight: 700;
  font-size: 16px;
  cursor: text;
  text-align: left;
`;

const RequiredMark = styled.span`
  color: #d32f2f;
`;

const CharCount = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 0.85rem;
  color: var(--color-primary-desat);
`;

const StyledTextarea = styled.textarea`
  width: 100%;
  margin-top: 6px;
  font-size: 16px;
  border-radius: 6px;
  padding: 10px 12px;
  border: 1px solid var(--color-primary-desat);
  transition: all 0.25s;
  min-height: 120px;
  resize: vertical;

  &:focus,
  &:active,
  &:focus-visible {
    border: 1px solid var(--color-primary-dark) !important;
    outline: none;
  }
`;

export interface ParagraphFieldProps {
  label: string;
  name: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  tooltip?: string;
  rows?: number;
}

const ParagraphField: React.FC<ParagraphFieldProps> = ({
  label,
  name,
  value,
  onChange,
  required = false,
  tooltip,
  rows = 5,
}) => {
  return (
    <FieldWrapper>
      <LabelRow htmlFor={name}>
        {label}
        {required && <RequiredMark>*</RequiredMark>}
        {tooltip && (
          <Tooltip title={tooltip}>
            <span style={{ display: "inline-flex", cursor: "help" }}>
              <FontAwesomeIcon
                icon={faCircleInfo}
                style={{
                  color: "var(--color-primary-desat)",
                  fontSize: "0.9rem",
                }}
              />
            </span>
          </Tooltip>
        )}
      </LabelRow>
      <StyledTextarea
        id={name}
        rows={rows}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={1200}
        aria-required={required}
      />
      <CharCount>{value.length}/1200</CharCount>
    </FieldWrapper>
  );
};

export default ParagraphField;
